import React from 'react';
import { FormCheckbox, FormDatePicker, FormNumberField, useDebouncedEffect } from '@lib/common';
import { SurveyOutreachFilters } from '@lib/state';
import { Grid } from '@material-ui/core';
import { FilterSection } from 'app/shared/components/filter-section';
import { FormContext, useForm } from 'react-hook-form';

interface Props {
  filters: SurveyOutreachFilters;
  onChange: (filters: SurveyOutreachFilters) => void;
}

export function SurveyFilter({ filters, onChange }: Props) {
  const form = useForm<SurveyOutreachFilters>({
    defaultValues: {
      ...filters,
    },
  });

  const { startDate, endDate, outreachCompleted, recordNumber } = form.watch();

  useDebouncedEffect(
    () => {
      onChange({ recordNumber, startDate, endDate, outreachCompleted });
    },
    300,
    [startDate, endDate, outreachCompleted, recordNumber, onChange]
  );

  return (
    <FilterSection>
      <FormContext {...form}>
        <Grid container spacing={2}>
          <Grid item md={2} xs={6}>
            <FormNumberField name="recordNumber" label="Reservation" fullWidth />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormDatePicker name="startDate" label="Start Date" fullWidth />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormDatePicker name="endDate" label="End Date" fullWidth />
          </Grid>
          <Grid item md={2} xs={6}>
            <FormCheckbox
              name="outreachCompleted"
              label={'Show Completed'}
              color="secondary"
              fullWidth
            />
          </Grid>
        </Grid>
      </FormContext>
    </FilterSection>
  );
}
